import React from 'react'
import { ServerConfig } from 'config'

import PaginatedList from '../../components/PaginatedList/PaginatedList'


const EcocontrolLogins = () => {

  return (
    <>
      <PaginatedList
        list_get_url={`${ServerConfig.SERVER_URL}/admin/ecocontrol-qr-attempts/`}
        date_search={true}
        show_timestamp_time={true}
        column_names={["id", "ecocontrol_id", "customer_id", "qrcode", "valid", "reason", "timestamp"]}
        header_names={["id", "ecocontrol_id", "customer_id", "QR code", "valid", "reason", "timestamp"]}
      />
    </>
  )
}

export default EcocontrolLogins
